module.exports = __webpack_public_path__ + "static/media/delivery-3.c6fcb8e6.png";